import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { useAxiosProvider } from "../providers/axios-provider.js";
import "react/jsx-runtime";
import "axios";
const Order = {
  ASC: "asc",
  DESC: "desc"
};
const OrderOptions = {
  createdDate: "createdDate",
  dueDate: "dueDate",
  feeRemaining: "amountRemaining",
  feeAmount: "amountTotal",
  appointmentStartTime: "appointment.startTime"
};
const getNoShowList = (axios) => async (clinicReferenceId, options, signal) => {
  const { data } = await axios.get(`/api/invoices/v1/noshow/clinics/${clinicReferenceId}`, {
    signal,
    params: {
      ...options ?? {}
    }
  });
  return data;
};
const useNoShowList = (clinicReferenceId, options) => {
  const { calmaster } = useAxiosProvider();
  if (!calmaster) {
    throw new Error("calmaster axios instance is not initialized");
  }
  const queryKey = useMemo(() => ["no-show-list", clinicReferenceId, options], [clinicReferenceId, options]);
  const { data, ...queryResult } = useQuery({
    queryKey,
    queryFn: ({ signal }) => getNoShowList(calmaster)(clinicReferenceId, options, signal),
    enabled: Boolean(clinicReferenceId),
    keepPreviousData: true
  });
  return {
    queryKey,
    queryResult,
    data: (data == null ? void 0 : data.content) ?? [],
    totalPages: (data == null ? void 0 : data.totalPages) ?? 0,
    totalElements: (data == null ? void 0 : data.totalElements) ?? 0
  };
};
export {
  Order,
  OrderOptions,
  useNoShowList
};
